import styled, { css } from 'styled-components';
import { Colors } from '../../../../ui';

export const TransformButton = styled.div<{ disabled?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    position: absolute;
    padding: 0.125rem 0.25rem;
    font-weight: 450;
    font-size: .875rem;
    border: 2px solid ${Colors.primaryLight};
    border-radius: 4px;
    background: white;
    color: ${Colors.primaryLight};
    pointer-events: all;
    user-select: none;
    white-space: nowrap;

    &:hover {
        background: ${Colors.primaryLight};
        color: white;
        cursor: pointer;
    }

    &:active {
        background: ${Colors.primary};
        color: white;
        border-color: ${Colors.primary};
    };

    ${p => p.disabled && css`
        pointer-events: none;
        opacity: 0.5;
        filter: grayscale(50%);
    `}
`;
